var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roma-page-content fill-height grey lighten-4"},[_c('v-container',[_c('EvaluationsHeader',{attrs:{"title":"Por revisar"}}),_c('EvaluationsContent',{attrs:{"items":4}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }